import { createLowlight, common } from 'lowlight';

/**
 * Shared lowlight instance for code-block syntax highlighting (highlight.js
 * grammars). One instance is reused by the editor and the read-only viewer so
 * they highlight identically.
 *
 * Replaces tiptap-extension-code-block-shiki: Shiki re-tokenized the whole doc
 * synchronously and dispatched a force-decoration transaction on every
 * keystroke, which — amplified by y-prosemirror Collaboration to ~10
 * transactions per key — froze the editor while typing. lowlight highlights
 * synchronously and cheaply with no per-keystroke transaction storm.
 *
 * `common` bundles ~37 widely-used languages (ts, js, python, rust, go, css,
 * html, json, yaml, bash, sql, java, etc.) — covering CODE_BLOCK_LANGUAGES.
 */
export const lowlight = createLowlight(common);

// Map our toolbar's language values that highlight.js exposes under a different
// grammar name, so picking them forces the right grammar instead of silently
// falling back to auto-detect:
//   html → xml grammar; jsx → javascript; tsx → typescript.
lowlight.registerAlias({
  xml: ['html'],
  javascript: ['jsx'],
  typescript: ['tsx'],
});
